import { useMyScheduleBeta } from "Pages/MyScheduleBeta/Hooks/useMyScheduleBeta";
import React from "react";
import { ScheduleStatus } from "utilFunctions/shared/ScheduleStatus";

const Unmarked = () => {
  const { NotMarkedChangeHandler, isNotmarkedVisible } = useMyScheduleBeta();
  return (
    <div className="d-flex align-items-center">
      <input
        className="form-check-input filterCheckbox mr-2"
        type="checkbox"
        checked={isNotmarkedVisible}
        onChange={NotMarkedChangeHandler}
      />
      <ScheduleStatus status={"Unmarked"}></ScheduleStatus>
    </div>
  );
};

export default Unmarked;
